import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ApiService, Request, Response, ResponsePost} from '@services/api.service';
import {OdooService} from '@services/odoo.service';
import {catchError, map, tap} from 'rxjs/operators';
import {of, throwError} from 'rxjs';
import {CommonModule, DatePipe} from '@angular/common';
import {TruncatePipe} from '../../truncate.pipe';
import {ClickedItem} from '../../app.component';
import {HttpClientModule} from '@angular/common/http';
import {PaginationComponent} from '@components/pagination/pagination.component';
import {SearchConfig} from '@components/my-requests/my-requests.component';
import {SearchPanelComponent} from '@components/search-panel/search-panel.component';

@Component({
  selector: 'app-procedures',
  imports: [CommonModule, DatePipe, TruncatePipe, HttpClientModule, PaginationComponent, SearchPanelComponent],
  templateUrl: './procedures.component.html',
  styleUrl: './procedures.component.css'
})
export class ProceduresComponent {

  @Input() type: "orders" | "communications" = "orders"

  @Output() rowClicked = new EventEmitter<ClickedItem>();
  @Output() navigate = new EventEmitter<string>();

  procedures: any[] = []
  pagedData: any[] = []
  itemsPerPage: number = 10;
  currentPage: number = 1;
  totalPages: number = 0;

  searchPanelConfig: SearchConfig[] = [
    {key: 'name', label: 'Nome', type: 'text'},
    {key: 'code', label: 'Codice', type: 'text'},
    {key: 'date_from', label: 'Dal', type: 'date'},
    {key: 'date_to', label: 'Al', type: 'date'},
  ]

  currentSort: {
    field: string; direction: 'asc' | 'desc' } = {
    field: 'id',
    direction: 'desc',
  }

  currentFilters: any = {}

  constructor(
    private odooService: OdooService,
    private apiService: ApiService
  ) {
  }

  ngOnInit(): void {
    this.fetchProcedures({})
  }

  onRowClicked(id: number) {

    this.apiService.getProcedure(id).pipe(
      tap((item) => this.rowClicked.emit({ type: 'procedure', item: item })),
      catchError(err => {
        return throwError(() => new Error(err))
      })
    ).subscribe();
  }

  fetchProcedures(params: any) {

    params = {
      ...params,
      direction: this.currentSort.direction,
      order: this.currentSort.field,
      type: this.type
    }

    this.apiService.getProcedures(params).pipe(
      map((response: ResponsePost) => {
        if (response.result.status != 'error') {
          return response.result.data
        } else {
          return []
        }
      }),
      catchError(error => {
        console.error("Errore nel recupero degli ordini di servizio", error);
        return of([])
      })
    ).subscribe(
      procedures => {
        this.procedures = procedures;
        this.totalPages = Math.ceil(this.procedures.length / this.itemsPerPage);
        this.paginateData();
      }
    )
  }

  paginateData() {
    const startIndex = (this.currentPage -1) * this.itemsPerPage;;
    const endIndex = startIndex + this.itemsPerPage;
    this.pagedData = this.procedures.slice(startIndex, endIndex);
  }

  goToPage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.paginateData()
    }
  }

  onSearchParamChange(params: any): void  {
    this.currentFilters = params
    this.fetchProcedures(params);
  }

  setOrder(field: string) {
    if (this.currentSort.field === field) {
      this.currentSort.direction = this.currentSort.direction === 'asc' ? 'desc' : 'asc';
    } else {
      this.currentSort.field = field;
      this.currentSort.direction = 'asc'
    }
    this.fetchProcedures(this.currentFilters)
  }


}
